module.exports = __webpack_public_path__ + "static/homepage-b8abe5825e66e468ffe7cedef74f7b9f.jpg";